import { cva } from 'class-variance-authority';

export const dialogVariants = cva(
  'backdrop:bg-color-backdrop bg-color-background-base m-0 min-h-full max-w-[900px] min-w-full flex-col',
  {
    variants: {
      variant: {
        default: '',
        bottomSheet:
          'c_bottom-sheet-dialog max-md:inset-[auto_0_0_0] max-md:h-auto max-md:max-h-[85dvh] max-md:min-h-[35dvh] max-md:rounded-t-md',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  },
);
